import useYouTubeAdditionalDetailsStep from './useYouTubeAdditionalDetailsStep';

export default useYouTubeAdditionalDetailsStep;
